document.addEventListener("DOMContentLoaded", function () {

	if (typeof Fancybox !== "undefined") {
		Fancybox.bind("[data-fancybox='gradient-gallery']", {
			Toolbar: {
				display: [
					"close"
				]
			},
			Carousel: {
				infinite: true
			}
		});
	}

});